<template>
  <div class="order-report-detail">
    <!-- 顶部导航栏 -->
    <van-nav-bar
      :title="typeName"
      left-arrow
      @click-left="goBack"
      fixed
      placeholder
      v-if="!isNativeApp"
    />

    <div class="form-container">
      <!-- 订单信息和申请类型卡片 -->
      <div class="order-info-application-card">
        <!-- 订单信息展示 -->
        <div class="order-info-section">
          <div class="car-info-item">
            <span>订单号</span>
            <span
              class="car-no"
            >{{ taskDetail.orderNo || "-" }}</span>
          </div>
          <div class="car-info-item">
            <span>车牌号</span>
            <span
              class="car-no"
            >{{ taskDetail.carNo || "-" }}</span>
          </div>
          <div class="car-info-item">
            <span>产品类型</span>
            <span
              class="car-no"
            >{{ taskDetail.productCategoryName || "-" }}</span>
          </div>
          <div class="car-info-item">
            <span>优惠信息</span>
            <span
              class="car-no"
            >{{ rightRemark || "-" }}</span>
          </div>
        </div>
      </div>
      <div
        class="form-section"
      >
        <div class="section-header">
          <span class="header-title">
            {{ headerTitle }}
          </span>
        </div>
        <div class="section-textarea">
          <van-field
            v-if="[
              WORK_ORDER_APP_TYPE.dispatch,
              WORK_ORDER_APP_TYPE.bargain,
              WORK_ORDER_APP_TYPE.order,
              WORK_ORDER_APP_TYPE.other,
            ].includes(type)"
            class="textarea-box"
            v-model="formData.content"
            label=""
            type="textarea"
            placeholder="请输入"
            maxlength="100"
            show-word-limit
            rows="3"
            autosize
          />
        </div>
        <div
          class="upload-section"
          v-if="[
            WORK_ORDER_APP_TYPE.bargain,
            WORK_ORDER_APP_TYPE.order,
            WORK_ORDER_APP_TYPE.other,
          ].includes(type)"
        >
          <div
            class="custom-uploader"
            v-if="isNativeApp"
          >
            <div class="img-box-section">
              <div
                class="img-box"
                v-for="(item, index) in formData.fileList"
                :key="index"
              >
                <img
                  :src="item.url"
                  @click="previewImageHandle(index)"
                >
                <div class="img-delete-btn">
                  <van-icon
                    name="cross"
                    class="delete-icon"
                    @click="deleteComfirmHandle(index)"
                  />
                </div>
              </div>

              <div
                v-if="formData.fileList.length < maxCount"
                class="img-upload-btn"
                @click="selectPicFromAlbum"
              />
            </div>
          </div>
          <van-uploader
            v-else
            v-model="formData.fileList"
            accept=".jpg, .png, .jpeg, .JPG, .PNG, .JPEG"
            :max-count="maxCount"
            :before-read="beforeRead"
            :after-read="afterRead"
            :before-delete="beforeDelete"
            @delete="delMediaById"
            class="custom-uploader"
          >
            <div
              class="img-upload-btn"
            />
          </van-uploader>
        </div>
        <div
          class="shortcut-phrases"
          v-if="[
            WORK_ORDER_APP_TYPE.dispatch,
            WORK_ORDER_APP_TYPE.order,
            WORK_ORDER_APP_TYPE.other,
          ].includes(type)"
        >
          <div
            v-for="(reason, index) in reasonTypes"
            :key="index"
            @click="addPhrase(reason.value)"
            class="phrase-tag"
          >
            {{ reason.value }}
          </div>
        </div>
        <div
          class="edit-section"
          v-if="[
            WORK_ORDER_APP_TYPE.appointment,
          ].includes(type)"
        >
          <div class="edit-box">
            <div class="apointment-info">
              <span class="apointment-info-label">救援时间：</span>
              <span class="apointment-info-value">{{ formData.appointmentTime || "" }}</span>
            </div>
            <div class="apointment-btn-box">
              <span
                class="apointment-btn"
                @click="editTime"
              >修改</span>
            </div>
          </div>
        </div>
        <div
          class="edit-section"
          v-if="[
            WORK_ORDER_APP_TYPE.address,
          ].includes(type)"
        >
          <div class="edit-box">
            <div class="address-box">
              <div class="address-title color-green">救援起点：</div>
              <div class="address-content">
                <div class="address-info">
                  {{ formData.rescueStartAddress || "" }}
                </div>
                <div class="address-btn-box">
                  <span
                    class="address-btn"
                    @click="editAddress('start')"
                  >修改</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          class="edit-section"
          v-if="[
            WORK_ORDER_APP_TYPE.address,
          ].includes(type) && isTrailer"
        >
          <div class="edit-box">
            <div class="address-box">
              <div class="address-title color-red">救援终点：</div>
              <div class="address-content">
                <div class="address-info">
                  {{ formData.rescueEndAddress || "" }}
                </div>
                <div class="address-btn-box">
                  <span
                    class="address-btn"
                    @click="editAddress('end')"
                  >修改</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          class="edit-section"
          v-if="[
            WORK_ORDER_APP_TYPE.project,
          ].includes(type)"
        >
          <div
            class="edit-box"
            @click="editProject"
          >
            <span class="project-info">{{ currentProjectName }}</span>
            <van-icon
              name="arrow"
              size="16"
              class="arrow-icon"
            />
          </div>
        </div>
      </div>
    </div>

    <div class="btn-box">
      <!-- 底部按钮 -->
      <van-row gutter="13">
        <van-col span="12">
          <van-button
            type="default"
            block
            plain
            @click="goBack"
          >取消</van-button>
        </van-col>
        <van-col span="12">
          <van-button
            type="info"
            color="#3399FF"
            block
            @click="submit"
            :loading="isSubmitting"
          >提交</van-button>
        </van-col>
      </van-row>
    </div>

    <!-- 确认弹窗 -->
    <ConfirmDialog
      ref="confirmDialog"
    />
    <!-- 日期选择器弹出层 -->
    <van-popup
      v-model="showDatePicker"
      round
      position="bottom"
    >
      <van-datetime-picker
        type="datetime"
        :min-date="dateRange.minDate"
        :max-date="dateRange.maxDate"
        :formatter="dateFormatter"
        @confirm="onDateConfirm"
        @cancel="showDatePicker = false"
      />
    </van-popup>
    <!-- 选择项目 -->
    <SelectListPopup
      ref="selectListPopupRef"
      title="请选择服务项目"
      :list="filterProductStandardSkusList"
      @confirm="onProjectConfirm"
    />
    <!-- 选择地址弹窗 -->
    <SelectLocation
      ref="selectLocationRef"
      @confirm="locationConfirm"
    />
  </div>
</template>

<script>
import {
  workOrderCreate,
  getProductStandardSkus
} from '@/common/apiReport.js';
import {
  getTaskDetail,
  getRightRemark
} from '@/common/apiPaic.js';
import { queryDictByCodes } from '@/common/api.js';
import {
  WORK_ORDER_APP_TYPE
} from '../common/constant.js';
import { debounce, cloneDeep } from 'lodash';
import { upload, getFileName } from '@/utils/ourOss';
import Compressor from 'compressorjs';
import ConfirmDialog from '@/components/confirmDialog.vue';
import dayjs from 'dayjs';
import SelectListPopup from '../components/selectListPopup.vue';
import SelectLocation from '../components/selectLocation.vue';
import jsApi from '@/common/jsApi';
import { ImagePreview } from 'vant';
import { generalProductCode } from '@/common/constant';
function initFormData() {
  return {
    content: '',
    fileList: [],
    appointmentTime: '',
    productSkuCode: '',
    rescueStartAddress: '',
    rescueStartLatitude: 0,
    rescueStartLongitude: 0,
    rescueEndAddress: '',
    rescueEndLatitude: 0,
    rescueEndLongitude: 0
  };
}

export default {
  name: 'OrderReportCreate',
  components: {
    ConfirmDialog,
    SelectListPopup,
    SelectLocation
  },
  data() {
    return {
      maxCount: 5,
      orderNo: '',
      taskNo: '',
      WORK_ORDER_APP_TYPE,
      taskDetail: {},
      rightRemark: '',
      reasonTypes: [],
      formData: initFormData(),
      // 提交状态
      isSubmitting: false,
      showDatePicker: false,
      productStandardSkusList: []
    };
  },
  computed: {
    // 拖车
    isTrailer() {
      return (
        this.taskDetail &&
        [generalProductCode.categoryCode_FL10000002, generalProductCode.categoryCode_FL90000002].includes(
          this.taskDetail.categoryCode
        )
      );
    },
    currentProjectName() {
      return this.productStandardSkusList.find(item => item.productSkuCode === this.formData.productSkuCode)?.productSkuName || this.taskDetail.productSkuName;
    },
    filterProductStandardSkusList() {
      return this.productStandardSkusList.filter(item => item.productSkuCode !== this.formData.productSkuCode) || [];
    },
    dateRange() {
      // 只能选择今天起，7天内的日期（含今天）
      const now = dayjs();
      const minDate = now.subtract(0, 'day');

      let maxDate = now.add(6, 'day');
      maxDate = maxDate.set('hour', 23);
      maxDate = maxDate.set('minute', 59);
      maxDate = maxDate.set('second', 59);

      return {
        minDate: new Date(minDate),
        maxDate: new Date(maxDate)
      };
    },
    headerTitle() {
      switch (this.type) {
        case WORK_ORDER_APP_TYPE.dispatch:
          return '请填写申请改派原因';
        case WORK_ORDER_APP_TYPE.appointment:
          return '请选择预约时间';
        case WORK_ORDER_APP_TYPE.address:
          return '请选择地址进行修改';
        case WORK_ORDER_APP_TYPE.project:
          return '请选择项目修改';
        case WORK_ORDER_APP_TYPE.bargain:
          return '请输入议价金额和原因';
        case WORK_ORDER_APP_TYPE.order:
          return '请输入报备内容';
        case WORK_ORDER_APP_TYPE.other:
          return '请输入问题内容';
        default:
          return true;
      }
    },
    // 根据不同类型判断提交按钮是否禁用
    isSubmitDisabled() {
      switch (this.type) {
        case WORK_ORDER_APP_TYPE.dispatch:
        case WORK_ORDER_APP_TYPE.bargain:
        case WORK_ORDER_APP_TYPE.order:
        case WORK_ORDER_APP_TYPE.other:
          return !this.formData.content;
        case WORK_ORDER_APP_TYPE.appointment:
          return !this.formData.appointmentTime;
        case WORK_ORDER_APP_TYPE.address:
          return false;
        case WORK_ORDER_APP_TYPE.project:
          return !this.formData.productSkuCode;
        default:
          return true;
      }
    },
    isNativeApp() {
      return this.$route.name === 'OrderReportAppCreate';
    }
  },
  created() {
    const { orderNo, taskNo } = this.$route.params;
    if (orderNo && taskNo) {
      this.orderNo = orderNo;
      this.taskNo = taskNo;
    }
    const { type, typeName } = this.$route.query;
    if (type && typeName) {
      this.type = type;
      this.typeName = typeName;
      this.setNavigationBarTitle(typeName);
    }
    this.init();
  },
  methods: {
    setNavigationBarTitle(title) {
      // 设置标题
      if (this.isNativeApp) {
        jsApi.setNavigationBar({
          title
        });
      }
    },
    init() {
      this.formData = initFormData();
      this.queryDictByCodes();
      this.getTaskDetail();
      this.getRightRemark();
    },
    async queryDictByCodes() {
      try {
        let codes = [];
        if (this.type === WORK_ORDER_APP_TYPE.dispatch) {
          codes = ['APP_DISPATCH_APPLY_TYPE'];
        } else if (this.type === WORK_ORDER_APP_TYPE.order) {
          codes = ['APP_ORDER_REPORT_CONTENT'];
        } else if (this.type === WORK_ORDER_APP_TYPE.other) {
          codes = ['APP_OTHER_ISSUE_CONTENT'];
        } else {
          return;
        }
        const res = await queryDictByCodes({
          codes
        });
        if (res && res.length > 0) {
          this.reasonTypes = res[0].kvs;
        }
      } catch (error) {
        console.log(error);
      }
    },
    async getTaskDetail(noLoading) {
      if (!(this.orderNo && this.taskNo)) {
        return;
      }
      if (!noLoading) {
        this.$toast.loading({
          message: '加载中...',
          forbidClick: true
        });
      }
      try {
        const data = await getTaskDetail({
          orderNo: this.orderNo,
          taskNo: this.taskNo
        });
        if (data) {
          this.taskDetail = data;
          if (this.type === WORK_ORDER_APP_TYPE.appointment) {
            this.formData.appointmentTime = data.appointmentTime;
          } else if (this.type === WORK_ORDER_APP_TYPE.project) {
            this.formData.productSkuCode = data.productSkuCode;
            this.getProductStandardSkus();
          } else if (this.type === WORK_ORDER_APP_TYPE.address) {
            this.formData.rescueStartAddress = data.contactAddress;
            this.formData.rescueStartLatitude = data.latitude;
            this.formData.rescueStartLongitude = data.longitude;
            this.formData.rescueEndAddress = data.destination;
            this.formData.rescueStartLatitude = data.destLatitude;
            this.formData.rescueEndLongitude = data.destLongitude;
          }
        }
        if (!noLoading) {
          this.$toast.clear();
        }
      } catch (error) {
        console.log(error);
      }
    },
    async getProductStandardSkus() {
      try {
        const data = await getProductStandardSkus({
          categoryCode: this.taskDetail.categoryCode,
          channelCompanyId: this.taskDetail.channelCompanyId
        });
        if (data) {
          this.productStandardSkusList = data || [];
        }
      } catch (error) {
        console.log(error);
      }
    },
    async getRightRemark() {
      if (!(this.orderNo && this.taskNo)) {
        return;
      }
      try {
        const data = await getRightRemark({
          orderNo: this.orderNo
        });
        this.rightRemark = data.resultValue;
      } catch (error) {
        console.log(error);
      }
    },
    async beforeRead(file) {
      return new Promise((resolve, reject) => {
        // 设置允许上传图片格式为jpg
        const FileExt = file.name.replace(/.+\./, '');
        const isLtFileType = ['jpg', 'png', 'jpeg'].includes(FileExt.toLowerCase());
        if (!isLtFileType) {
          this.$toast('上传文件只能是jpg, png, jpeg格式');
          reject();
          return false;
        }
        const isLtFileSize = file.size / 1024 / 1024 < 10;

        if (!isLtFileSize) {
          this.$toast('上传文件大小不能超过 10MB!');
          reject();
          return false;
        }

        const isLtFileName = getFileName(file.name).length <= 50;
        // 限制文件名
        if (!isLtFileName) {
          this.$toast('文件名不能超过50个字符');
          reject();
          return false;
        }
        resolve(file);
      });
    },
    doCompressor(file) {
      return new Promise((resolve, reject) => {
        // 将图片压缩到1M以内
        const compressor = new Compressor(file, {
          strict: false,
          success: (result) => {
            resolve(result);
          },
          error(err) {
            console.log(err.message);
          }
        });
        console.log(compressor);
      });
    },
    // 自定义上传
    async afterRead({ file }) {
      console.log(file.name, 'afterRead file.name');
      console.log(file, 'afterRead file');

      try {
        this.$toast.loading({
          message: '正在上传...',
          forbidClick: true
        });
        let realFile = cloneDeep(file);
        // compressorjs 默认开启 checkOrientation 选项
        // 会将图片修正为正确方向
        realFile = await this.doCompressor(file);
        const res = await upload(realFile);
        if (!(String(res.data.code) === '0')) {
          this.$toast(res.data.message);
          return;
        }
        const data = res.data.data;
        console.log('res: ', res);

        const media = {
          isImage: true,
          'url': data.accessUrl,
          'fileName': file.name,
          'fileId': data.picId
        };
        this.formData.fileList.splice(this.formData.fileList.length - 1, 1, media);
        console.log('this.formData.fileList', this.formData.fileList);
      } catch (error) {
        console.log(error);
      } finally {
        this.$toast.clear();
      }
    },
    async beforeDelete(file) {
      return new Promise((resolve, reject) => {
        const confirmText = '确定删除该图片吗?';
        this.$refs.confirmDialog.open({
          confirmText,
          confirmCallback: () => {
            console.log('confirmCallback');
            resolve(file);
          },
          cancelCallback: () => {
            reject();
          }
        });
      });
    },
    async delMediaById(file) {
      // 组件会直接删除图片，这里是本地图片，没有接口请求，所以不需要做任何操作
    },
    // 添加快捷短语
    addPhrase(phrase) {
      if (this.formData.content.length + phrase.length <= 100) {
        this.formData.content += (this.formData.content ? '，' : '') + phrase;
      } else {
        this.$toast('字数超出限制');
      }
    },
    // 提交报备
    async submitReport() {
      if (this.isSubmitDisabled) {
        let errorMsg = '';
        switch (this.type) {
          case WORK_ORDER_APP_TYPE.dispatch:
            errorMsg = '请填写申请改派原因';
            break;
          case WORK_ORDER_APP_TYPE.appointment:
            errorMsg = '请选择预约时间';
            break;
          case WORK_ORDER_APP_TYPE.address:
            errorMsg = '请至少选择一个新地址';
            break;
          case WORK_ORDER_APP_TYPE.project:
            errorMsg = '请选择项目';
            break;
          case WORK_ORDER_APP_TYPE.bargain:
            errorMsg = '请输入议价金额和原因';
            break;
          case WORK_ORDER_APP_TYPE.order:
            errorMsg = '请输入报备内容';
            break;
          case WORK_ORDER_APP_TYPE.other:
            errorMsg = '请输入问题内容';
            break;
          default:
            errorMsg = '请填写必填信息';
        }
        this.$toast(errorMsg);
        return;
      }
      const params = {};
      for (const key in this.formData) {
        if (!Object.prototype.hasOwnProperty.call(this.formData, key)) continue;

        const element = this.formData[key];
        if (element != '' || (element instanceof Array && element.length > 0)) {
          params[key] = element;
        }
      }
      // 校验是否修改
      if (this.type === WORK_ORDER_APP_TYPE.appointment) {
        if (params.appointmentTime === this.taskDetail.appointmentTime) {
          this.$toast('未做修改，请修改后提交');
          return;
        }
      } else if (this.type === WORK_ORDER_APP_TYPE.project) {
        if (params.productSkuCode === this.taskDetail.productSkuCode) {
          this.$toast('未做修改，请修改后提交');
          return;
        }
      } else if (this.type === WORK_ORDER_APP_TYPE.address) {
        if (params.rescueStartAddress === this.taskDetail.contactAddress && params.rescueEndAddress === this.taskDetail.destination) {
          this.$toast('未做修改，请修改后提交');
          return;
        } else {
          // 未做修改的地址清除
          if (params.rescueStartAddress === this.taskDetail.contactAddress) {
            delete params.rescueStartAddress;
            delete params.rescueStartLatitude;
            delete params.rescueStartLongitude;
          } else if (params.rescueEndAddress === this.taskDetail.destination) {
            delete params.rescueEndAddress;
            delete params.rescueEndLatitude;
            delete params.rescueEndLongitude;
          }
        }
      }
      this.isSubmitting = true;
      this.$toast.loading({
        message: '正在提交...',
        forbidClick: true
      });
      try {
        await workOrderCreate({
          appType: this.type,
          orderNo: this.orderNo,
          ...params
        });
        this.goBack();
      } catch (error) {
        console.log(error);
      } finally {
        this.$toast.clear();
        this.isSubmitting = false;
      }
    },
    goBack() {
      // 检查是否有上一页可以返回
      if (window.history.length <= 2) {
        // 如果没有上一页或者历史记录为空，直接跳转到OrderReportAppBase页面
        const { orderNo, taskNo } = this.$route.params;
        this.$router.replace({
          name: this.isNativeApp ? 'OrderReportAppBase' : 'OrderReportBase',
          params: {
            orderNo,
            taskNo
          }
        });
      } else {
        // 否则正常返回上一页
        this.$router.go(-1);
      }
    },
    submit: debounce(
      async function() {
        // 提交
        this.submitReport();
      },
      1000,
      { leading: true, trailing: false }
    ),
    async editTime() {
      this.showDatePicker = true;
    },
    onDateConfirm(date) {
      this.showDatePicker = false;
      this.formData.appointmentTime = dayjs(date).format('YYYY-MM-DD HH:mm');
    },
    dateFormatter(type, val) {
      switch (type) {
        case 'year':
          return val + '年';
        case 'month':
          return val + '月';
        case 'day':
          return val + '日';
        case 'hour':
          return val + '点';
        case 'minute':
          return val + '分';
        default:
          return val;
      }
    },
    async editProject() {
      this.$refs.selectListPopupRef?.open();
    },
    onProjectConfirm(skuItem) {
      this.formData.productSkuCode = skuItem.productSkuCode;
    },
    editAddress(type) {
      if (this.isNativeApp) {
        this.selectAddress(type);
      } else {
        this.$refs.selectLocationRef.open(type);
      }
    },
    locationConfirm(type, selectedAddr) {
      const province = selectedAddr.pname || '';
      const city = selectedAddr.cityname || '';
      const address = selectedAddr.address || '';
      const name = selectedAddr.name || '';
      const destination = `${province}${city}${address}${name}`;
      if (type === 'start') {
        this.formData.rescueStartAddress = destination;
        this.formData.rescueStartLatitude = selectedAddr.location?.lat;
        this.formData.rescueStartLongitude = selectedAddr.location?.lng;
      } else {
        this.formData.rescueEndAddress = destination;
        this.formData.rescueEndLatitude = selectedAddr.location?.lat;
        this.formData.rescueEndLongitude = selectedAddr.location?.lng;
      }
    },
    // app原生选择图片
    async selectPicFromAlbum() {
      try {
        const maxCount = this.maxCount - this.formData.fileList.length;
        const res = await jsApi.selectPicFromAlbum({
          maxCount
        });
        res.data.imgUploadList.forEach(data => {
          const media = {
            isImage: true,
            'url': data.fileUrl,
            'fileName': data.fileName,
            'fileId': data.fileId
          };
          // this.formData.fileList.splice(this.formData.fileList.length - 1, 1, media);
          this.formData.fileList.push(media);
        });
      } catch (error) {
        console.log(error);
      }
    },
    previewImageHandle(index) {
      const images = (this.formData.fileList || []).map(item => item.url);
      ImagePreview({ images, startPosition: index });
    },
    deleteComfirmHandle(index) {
      const confirmText = '确定删除该图片吗?';
      this.$refs.confirmDialog.open({
        confirmText,
        confirmCallback: () => {
          this.formData.fileList.splice(index, 1);
        }
      });
    },
    // app原生选择地址
    async selectAddress(type) {
      try {
        const res = await jsApi.selectAddress({
          title: type === 'start' ? '修改起点' : '修改终点'
        });
        const data = res.data;
        if (type === 'start') {
          this.formData.rescueStartAddress = data.address;
          this.formData.rescueStartLatitude = data.latitude;
          this.formData.rescueStartLongitude = data.longitude;
        } else {
          this.formData.rescueEndAddress = data.address;
          this.formData.rescueEndLatitude = data.latitude;
          this.formData.rescueEndLongitude = data.longitude;
        }
      } catch (error) {
        console.log(error);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.order-report-detail {
  min-height: 100vh;
  background-color: #f5f5f5;
  padding-bottom: 80px;
  box-sizing: border-box;

  ::v-deep{
    .van-nav-bar {
      .van-nav-bar__left {
        .van-icon {
          color: #565656;
        }
      }
    }
  }
}

.form-container {
  padding: 12px;
  padding-bottom: 72px;

  .order-info-application-card {
    background-color: #fff;
    border-radius: 8px;
    overflow: hidden;
    padding: 16px;

    & + .order-info-application-card {
      margin-top: 12px;
    }
    .order-info-section {
      .car-info-item {
        display: flex;
        font-size: 15px;
        color: #999999;
        letter-spacing: -0.38px;
        text-align: justify;
        font-weight: 400;
        line-height: 21px;

        & + .car-info-item {
          padding-top: 12px;
        }
        span {
          &:first-child {
            flex: 0 0 74px;
          }
          & + span {
            color: #383838;
          }
        }
      }
    }
  }
}

.form-section {
  background-color: #fff;
  border-radius: 8px;
  overflow: hidden;
  margin-top: 12px;

  .edit-section {
    padding: 0 16px 16px;
    .edit-box {
      background: #F5F6F7;
      border-radius: 8px;
      padding: 16px 12px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .apointment-info {
        font-size: 15px;
        letter-spacing: -0.38px;
        font-weight: 400;
        line-height: 21px;
        .apointment-info-label {
          color: #787878;
        }
        .apointment-info-value {
          color: #383838;
        }
      }
      .apointment-btn-box {
        font-size: 15px;
        letter-spacing: -0.38px;
        line-height: 21px;
        text-align: right;
        font-weight: 400;
        .apointment-btn {
          color: #3399FF;
        }
      }

      .project-info {
        font-size: 15px;
        color: #383838;
        letter-spacing: -0.38px;
        line-height: 21px;
        font-weight: 400;
      }
      .arrow-icon {
        color: #ccc;
      }

      .address-box {
        width: 100%;
        .address-title {
          font-size: 15px;
          letter-spacing: -0.38px;
          font-weight: 400;
          line-height: 21px;
          padding-bottom: 8px;
          &.color-green {
            color: #5EC360;
          }
          &.color-red {
            color: #F32222;
          }
        }
        .address-content {
          display: flex;
          justify-content: space-between;

          font-size: 15px;
          letter-spacing: -0.38px;
          font-weight: 400;
          line-height: 21px;
          .address-info {
            color: #383838;
          }
          .address-btn-box {
            color: #3399FF;
            margin-left: 12px;
            flex: none;
          }
        }
      }
    }
  }
}

.section-header {
  display: flex;
  align-items: center;
  padding: 16px 16px 8px;

  .header-title {
    font-size: 15px;
    color: #383838;
    letter-spacing: -0.38px;
    line-height: 21px;
    text-align: justify;
    font-weight: 500;
  }
}

.section-textarea {
  padding: 0 16px;
}

.textarea-box {
  background: #FFFFFF;
  border: 1px solid rgba(200,200,200,1);
  border-radius: 8px;
  padding: 12px;
  font-size: 15px;
  color: #383838;
  letter-spacing: -0.38px;
  line-height: 21px;
  font-weight: 400;
}

.shortcut-phrases {
  padding: 4px 16px 16px;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;

  .phrase-tag {
    background: #EEEFF0;
    border-radius: 8px;
    padding: 7px 10px;
    margin-right: 12px;
    margin-top: 12px;
    cursor: pointer;
    font-size: 13px;
    color: #383838;
    letter-spacing: -0.33px;
    font-weight: 400;
  }
}

.upload-section {
  .custom-uploader {
    padding: 8px 0 8px 8px;
    ::v-deep {
      .van-uploader__preview {
        margin: 8px;
      }
      .van-uploader__preview-image {
        box-sizing: border-box;
        width: 96px;
        height: 96px;
        background: #f1f1f1;
        border-radius: 8px;
      }
    }
    .img-upload-btn{
      position: relative;

      display: -webkit-box;
      display: -webkit-flex;
      display: flex;
      align-items: center;
      flex-direction: column;
      justify-content: center;

      box-sizing: border-box;
      width: 96px;
      height: 96px;
      margin: 8px;
      background-image: url(~@/assets/img/orderReport/icon-uploader.png);

      background-color: #f7f8fa;
      background-repeat:no-repeat;
      background-position: center center;
      background-size: auto 100%;

      .van-icon {
        color: #dcdee0;

        font-size: 24px;
      }
    }
    .img-box-section {
      display: flex;
      flex-wrap: wrap;
      .img-box {
        position: relative;
        box-sizing: border-box;
        width: 96px;
        height: 96px;
        background: #f1f1f1;
        border-radius: 8px;
        margin: 8px;
        img {
          width: 100%;
          height: 100%;
        }
        .img-delete-btn {
          position: absolute;
          top: 0;
          right: 0;
          width: 14px;
          height: 14px;
          background-color: rgba(0, 0, 0, .7);
          border-radius: 0 0 0 12px;
          .delete-icon {
            position: absolute;
            top: -2px;
            right: -2px;
            color: #fff;
            font-size: 16px;
            -webkit-transform: scale(.5);
            transform: scale(.5);
          }
        }
      }
    }
  }
}

.btn-box{
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 10px 12px;

  background: #FFFFFF;
  .van-button{
    height: 40px;
    padding: 9px 10px;

    text-align: center;
    letter-spacing: -0.38px;
    line-height: 21px;

    border-radius: 8px;

    font-size: 15px;
    font-weight: 400;
    line-height: 21px;

    &.van-button--default{
      color: #646464;
      border: 1px solid rgba(200,200,200,1);
      background: #FFFFFF;
    }

    &.van-button--info{
      color: #FFFFFF;
      border: 1px solid #3399FF;
      background: #3399FF;
    }
  }
}
</style>
